import { useEffect, useState } from "react";
import api from "@/lib/api";

// Module-level cache of unverified (user-added, not yet promoted) circuit names per sport.
const cache = {}; // sport -> { promise, set }

function fetchSport(sport) {
    if (!cache[sport]) cache[sport] = { promise: null, set: null };
    if (!cache[sport].promise) {
        cache[sport].promise = api
            .get(`/circuits/user?sport=${sport}`)
            .then((r) => {
                const set = new Set((r.data || []).filter((c) => !c.verified).map((c) => c.name.toLowerCase()));
                cache[sport].set = set;
                return set;
            })
            .catch(() => new Set());
    }
    return cache[sport].promise;
}

export function invalidateUnverified(sport) {
    if (sport) delete cache[sport];
    else Object.keys(cache).forEach((k) => delete cache[k]);
}

/** Returns a Set of lowercased unverified circuit names for a sport (loads lazily). */
export function useUnverifiedCircuits(sport) {
    const [set, setSet] = useState(() => cache[sport]?.set || new Set());
    useEffect(() => {
        let alive = true;
        if (!sport) return;
        if (cache[sport]?.set) { setSet(cache[sport].set); return; }
        fetchSport(sport).then((s) => { if (alive) setSet(s); });
        return () => { alive = false; };
    }, [sport]);
    return set;
}
